module.exports = __webpack_public_path__ + "../resources/img/social-login-facebook.f20949e8.svg";